import { DvaReducer } from '@/models/shared';
import { Subscription } from 'dva';
import type { ExhibitInfoPageModelType, ChangeAction, InformExhibitInfoPageModelState } from './types';
import { initialState } from './initialState';
import { pageEffects } from './pageEffects';
import { exhibitEffects } from './exhibitEffects';
import { graphEffects } from './graphEffects';
import { sideExhibitEffects } from './sideExhibitEffects';
import { attrEffects } from './attrEffects';
import { drawerEffects } from './drawerEffects';

export type { InformExhibitInfoPageModelState };
export * from './types';
export { mergeRules } from './helpers';

const Model: ExhibitInfoPageModelType = {
  namespace: 'informExhibitInfoPage',
  state: initialState,
  effects: {
    ...pageEffects,
    ...exhibitEffects,
    ...graphEffects,
    ...sideExhibitEffects,
    ...attrEffects,
    ...drawerEffects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {

    },
  },
};

export default Model;
